export const LEGAL_ROUTES = {
	PRIVACY: "/privacy",
	TERMS_OF_USE: "/terms-of-use",
} as const;
